<template>
	<v-row v-if="!loading" class="ma-0 pb-offset">
		<v-col class="pa-0">

			<show v-if="models.compliancenonconformity"
				:id="id"
				:models="models"
				:infos="infos"
				topClass=""
			></show>

			<!-- Ciclo CAPA -->
			<v-card v-if="nc" class="background-2 round-card mt-4">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3 mb-0">Ciclo CAPA</p>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-4">
					<div class="d-flex align-center flex-wrap">
						<span class="mr-3">Stato attuale:</span>
						<v-chip :color="statusMeta(nc.status).color" dark label class="mr-4">
							<v-icon left small>{{ statusMeta(nc.status).icon }}</v-icon>
							{{ statusMeta(nc.status).text }}
						</v-chip>
						<v-spacer></v-spacer>
						<v-btn v-for="t in nc.available_transitions" :key="t" small class="ml-2 mb-1"
							:color="statusMeta(t).color" dark @click="transition(t)">
							<v-icon left small>{{ statusMeta(t).icon }}</v-icon>
							{{ statusMeta(t).text }}
						</v-btn>
					</div>
					<p v-if="nc.verification_date" class="mt-3 mb-0 grey--text">
						Verifica efficacia: {{ nc.verification_date }}
						<span v-if="nc.is_effective === true" class="green--text">— efficace</span>
						<span v-else-if="nc.is_effective === false" class="red--text">— non efficace</span>
					</p>
					<p v-if="nc.source_type === 'complianceauditfinding'" class="mt-2 mb-0 info--text">
						<v-icon small color="info">mdi-clipboard-check</v-icon> Generata da un rilievo di audit
					</p>
				</v-card-text>
			</v-card>

			<!-- Norme -->
			<v-card v-if="nc" class="background-2 round-card mt-4">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3 mb-0">Norme e requisiti</p>
					<v-spacer></v-spacer>
					<v-btn text color="primary" small @click="openTagsDialog">
						<v-icon left small>mdi-pencil</v-icon> Modifica
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-4">
					<div class="mb-3">
						<span class="grey--text mr-2">Norme:</span>
						<template v-if="nc.norms && nc.norms.length">
							<v-chip v-for="n in nc.norms" :key="n.value" :color="n.color || 'primary'" dark small class="mr-1" label>{{ n.text }}</v-chip>
						</template>
						<span v-else class="grey--text">— nessuna —</span>
					</div>
					<div>
						<span class="grey--text mr-2">Requisiti:</span>
						<template v-if="nc.requirements && nc.requirements.length">
							<v-chip v-for="r in nc.requirements" :key="r.value" outlined small class="mr-1 mb-1">{{ r.clause }} — {{ r.title }}</v-chip>
						</template>
						<span v-else class="grey--text">— nessuno —</span>
					</div>
				</v-card-text>
			</v-card>

			<dms-uploader class="mt-4" :id="id" attachable-type="compliancenonconformity"></dms-uploader>

			<v-tooltip top>
				<template v-slot:activator="{ on: tooltip }">
					<v-fab-transition>
						<v-btn v-on="{ ...tooltip }" @click.native="$eventBusUtility.goTo($router, 'compliancenonconformities-edit', id)"
							color="primary" dark fixed bottom right fab>
							<v-icon>edit</v-icon>
						</v-btn>
					</v-fab-transition>
				</template>
				<span>Modifica</span>
			</v-tooltip>

			<v-dialog v-model="tagsDialog" max-width="640" persistent>
				<v-card class="background-2 round-card">
					<v-card-title class="pa-3"><p class="pl-2 pl-xl-3 mb-0">Norme e requisiti</p></v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<v-autocomplete v-model="form.norms" :items="normOptions" item-text="text" item-value="value"
							label="Norme applicabili" outlined dense :menu-props="{'offset-y': true}" multiple chips small-chips deletable-chips prepend-icon="mdi-certificate"></v-autocomplete>
						<v-autocomplete v-model="form.requirements" :items="requirementOptions" item-text="label" item-value="value"
							label="Requisiti / controlli" outlined dense :menu-props="{'offset-y': true}" multiple chips small-chips deletable-chips prepend-icon="mdi-format-list-checks"></v-autocomplete>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions class="pa-3">
						<v-spacer></v-spacer>
						<v-btn text color="info" @click="tagsDialog = false">Annulla</v-btn>
						<v-btn text color="primary" :loading="saving" @click="saveTags">Salva</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'ComplianceNonconformity',

	props: { id: Number },

	data() {
		return {
			loading: true,
			models: {},
			infos: {},
			tagsDialog: false,
			saving: false,
			form: { norms: [], requirements: [] },
			normOptions: [],
			requirementOptions: [],
			statusMap: {
				aperta:   { text: 'Aperta',       color: '#f44336', icon: 'mdi-folder-open' },
				analisi:  { text: 'Analisi cause', color: '#ff9800', icon: 'mdi-magnify-scan' },
				azione:   { text: 'Azione',        color: '#2196f3', icon: 'mdi-wrench' },
				verifica: { text: 'Verifica',      color: '#9c27b0', icon: 'mdi-check-decagram' },
				chiusa:   { text: 'Chiusa',        color: '#4caf50', icon: 'mdi-folder-check' }
			}
		}
	},

	computed: {
		nc() { return this.models.compliancenonconformity }
	},

	created() { this.load() },

	methods: {
		load() {
			this.loading = true
			this.axios.get('compliancenonconformities/' + this.id).then(response => {
				this.models = response.data.models
				this.infos = response.data.infos
				this.loading = false
			}, () => {
				this.loading = false
				this.$store.commit('setSnackbarError')
			})
		},
		statusMeta(status) {
			return this.statusMap[status] || { text: status, color: 'grey', icon: 'mdi-help-circle' }
		},
		transition(target) {
			this.axios.post('compliancenonconformities/' + this.id + '/transition', { status: target }).then(() => {
				this.$store.commit('setSnackbar', { value: true, color: 'success', text: 'Stato aggiornato', timeout: 4000 })
				this.load()
			}, error => {
				const msg = error.response && error.response.data ? error.response.data.message : 'Errore nel cambio di stato'
				this.$store.commit('setSnackbar', { value: true, color: 'error', text: msg, timeout: 6000 })
			})
		},
		openTagsDialog() {
			this.form.norms = (this.nc.norms || []).map(n => n.value)
			this.form.requirements = (this.nc.requirements || []).map(r => r.value)
			this.requirementOptions = (this.nc.requirements || []).map(r => ({ value: r.value, label: r.clause + ' — ' + r.title }))
			this.loadNormOptions()
			this.tagsDialog = true
		},
		loadNormOptions() {
			this.axios.get('compliance-norms-options').then(r => { this.normOptions = r.data.data })
		},
		loadRequirementOptions() {
			this.axios.get('compliance-requirements-options').then(r => {
				this.requirementOptions = r.data.data.map(x => ({ value: x.value, label: x.text }))
			})
		},
		saveTags() {
			this.saving = true
			this.axios.put('compliancenonconformities/' + this.id, { norms: this.form.norms, requirements: this.form.requirements }).then(() => {
				this.saving = false
				this.tagsDialog = false
				this.$store.commit('setSnackbar', { value: true, color: 'success', text: 'Salvato', timeout: 4000 })
				this.load()
			}, () => {
				this.saving = false
				this.$store.commit('setSnackbarError')
			})
		}
	},

	watch: {
		tagsDialog(open) {
			if (open && !this.requirementOptions.length) this.loadRequirementOptions()
		}
	}
}
</script>
